import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

const skeletonRows = [
  'monthly-rate',
  'term',
  'interest-rate',
  'loan-amount',
  'total-cost',
] as const;

export const CompactAndColumn = () => (
  <div className="flex w-full flex-col gap-2 p-2 lg:flex-row lg:gap-4">
    <div className="flex shrink grow basis-1/2 flex-col gap-2">
      <Skeleton className="w-full" style={{ height: '145px' }} />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-2.5 w-full" />
    </div>
    <div className="flex shrink grow basis-1/2 flex-col gap-2">
      {skeletonRows.map((row) => (
        <Skeleton className="h-2 w-full" key={row} />
      ))}
    </div>
  </div>
);
